
import {Customer} from "./customer";

export const CustomerList = [
        {
        id: 1,
        name: 'Fernandez Moledo,Inc #3',
        address: 'Address1,city,state,zipcode',
        visit:12,
        phone:'(787)-758-1616',
        customertype:'customer Type',
        email:'ravi@gmail.com',
        distance:'0.15mi',
        customer_number: 'A00015',
        type:'Customer Type',
        last_visit:'24 days since last visit',
        total_sales:'$ 803,774.94',
        sales_in_90_days:'$ 15,0025.36',
        available_Credit:'$14,750.00',
        open_order:'$2,500.00',
        amount_invoiced:'$15,250.00',
        amount_overdue:'$250.00',
        credit_limit:'$30,000',
        payment_term:'NET 15',
        payment_method:'Invoices',
        price_list:'GF',
        street_name:'Street Name',
        city:'city',
        state:'state',
        zipcode:'zipcode',
         hold:'Active'

    },

        {
        id: 2,
        name: 'Tamil Alejandro Rodriguez',
        address: 'Address1,city,state,zipcode',
        visit:121,
        phone:'(787)-758-1616',
        customertype:'customerType',
        email:'hemu@gmail.com',
        distance:'0.12mi',
        customer_number: 'A00096',
        type:'Customer Type',
        last_visit:'24 days since last visit',
        total_sales:'$ 803,774.94',
        sales_in_90_days:'$ 15,0025.36',
        available_Credit:'$14,750.00',
        open_order:'$2,500.00',
        amount_invoiced:'$15,250.00',
        amount_overdue:'$250.00',
        credit_limit:'$30,000',
        payment_term:'NET 15',
        payment_method:'Invoices',
        price_list:'GF',
        street_name:'Street Name',
        city:'city',
        state:'state',
        zipcode:'zipcode',
        hold:'OnHold'



    },
        {
        id: 3,
        name: 'Blanco Velez Stores, Inc ',
        address: 'Address1,city,state,zipcode',
        visit:24,
        phone:'(787)-758-1616',
        customertype:'customerType',
        email:'siri567@gmail.com',
        distance:'0.16mi',
        customer_number: 'A00107',
        type:'Customer Type',
        last_visit:'24 days since last visit',
        total_sales:'$ 803,774.94',
        sales_in_90_days:'$ 15,0025.36',
        available_Credit:'$14,750.00',
        open_order:'$2,500.00',
        amount_invoiced:'$15,250.00',
        amount_overdue:'$250.00',
        credit_limit:'$30,000',
        payment_term:'NET 15',
        payment_method:'Invoices',
        price_list:'GF',
        street_name:'Street Name',
        city:'city',
        state:'state',
        zipcode:'zipcode',
         hold:'Active'

    }, 
            {
        id: 4,
        name: 'Tamil Alejandro Rodriguez',
        address: 'Address1,city,state,zipcode',
        visit:34,
        phone:'(787)-758-1616',
        customertype:'customer Type',
        email:'rani12@gmail.com',
        distance:'3.36mi',
        customer_number: 'A00096',
        type:'Customer Type',
        last_visit:'24 days since last visit',
        total_sales:'$ 803,774.94',
        sales_in_90_days:'$ 15,0025.36',
        available_Credit:'$14,750.00',
        open_order:'$2,500.00',
        amount_invoiced:'$15,250.00',
        amount_overdue:'$250.00',
        credit_limit:'$30,000',
        payment_term:'NET 15',
        payment_method:'Invoices',
        price_list:'GF',
        street_name:'Street Name',
        city:'city',
        state:'state',
        zipcode:'zipcode',
         hold:'Active'

    },
            {
        id: 5,
        name: 'Fernandez Moledo, Inc #6',
        address: 'Address1,city,state,zipcode',
        visit:88,
        phone:'(787)-758-1616',
        customertype:'customer Type',
        email:'srivani67@gmail.com',
        distance:'5.89mi',
        customer_number: 'A00135',
        type:'Customer Type',
        last_visit:'24 days since last visit',
        total_sales:'$ 803,774.94',
        sales_in_90_days:'$ 15,0025.36',
        available_Credit:'$14,750.00',
        open_order:'$2,500.00',
        amount_invoiced:'$15,250.00',
        amount_overdue:'$250.00',
        credit_limit:'$30,000',
        payment_term:'NET 15',
        payment_method:'Invoices',
        price_list:'GF',
        street_name:'Street Name',
        city:'city',
        state:'state',
        zipcode:'zipcode', 
        hold:'Active'

    },
            {
        id: 6,
        name: 'Tamil Alejandro Rodriguez',
        address: 'Address1,city,state,zipcode',
        visit:128,
        phone:'(787)-758-1616',
        customertype:'customer Type',
        email:'srivani67@gmail.com',
        distance:'8.82mi',
        customer_number: 'A00135',
        type:'Customer Type',
        last_visit:'24 days since last visit',
        total_sales:'$ 803,774.94',
        sales_in_90_days:'$ 15,0025.36',
        available_Credit:'$14,750.00',
        open_order:'$2,500.00',
        amount_invoiced:'$15,250.00',
        amount_overdue:'$250.00',
        credit_limit:'$30,000',
        payment_term:'NET 15',
        payment_method:'Invoices',
        price_list:'GF',
        street_name:'Street Name',
        city:'city',
        state:'state',
        zipcode:'zipcode',
         hold:'Active'

    }



];

export const SortedList = [

         {
        id: 1,
        name: 'Blanco Velez Stores, Inc',
        address: 'Address1,city,state,zipcode',
        visit:'12 days sice last visit',
        phone:'(787)-758-1616',
        customertype:'customerType',
        email:'siri567@gmail.com',
        distance:'0.15mi',
        customer_number: 'A00107',
        type:'Customer Type',
        last_visit:'24 days since last visit',
        total_sales:'$ 803,774.94',
        sales_in_90_days:'$ 15,0025.36',
        available_Credit:'$14,750.00',
        open_order:'$2,500.00',
        amount_invoiced:'$15,250.00',
        amount_overdue:'$250.00',
        credit_limit:'$30,000',
        payment_term:'NET 15',
        payment_method:'Invoices',
        price_list:'GF',
        street_name:'Street Name',
        city:'city',
        state:'state',
        zipcode:'zipcode'


    }, 
        {
        id: 2,
        name: 'Fernandez Moledo,Inc #3',
        address: 'Address1,city,state,zipcode',
        visit:'24 days sice last visit',
        phone:'(787)-758-1616',
        customertype:'customer Type',
        email:'ravi@gmail.com',
        distance:'0.05mi',
        customer_number: 'A00015',
        type:'Customer Type',
        last_visit:'24 days since last visit',
        total_sales:'$ 803,774.94',
        sales_in_90_days:'$ 15,0025.36',
        available_Credit:'$14,750.00',
        open_order:'$2,500.00',
        amount_invoiced:'$15,250.00',
        amount_overdue:'$250.00',
        credit_limit:'$30,000',
        payment_term:'NET 15',
        payment_method:'Invoices',
        price_list:'GF',
        street_name:'Street Name',
        city:'city',
        state:'state',
        zipcode:'zipcode'

    },

      
            {
        id: 3,
        name: 'Fernandez Moledo, Inc #6',
        address: 'Address1,city,state,zipcode',
        visit:'88 days sice last visit',
        phone:'(787)-758-1616',
        customertype:'customer Type',
        email:'srivani67@gmail.com',
        distance:'5.89mi',
        customer_number: 'A00015',
        type:'Customer Type',
        last_visit:'24 days since last visit',
        total_sales:'$ 803,774.94',
        sales_in_90_days:'$ 15,0025.36',
        available_Credit:'$14,750.00',
        open_order:'$2,500.00',
        amount_invoiced:'$15,250.00',
        amount_overdue:'$250.00',
        credit_limit:'$30,000',
        payment_term:'NET 15',
        payment_method:'Invoices',
        price_list:'GF',
        street_name:'Street Name',
        city:'city',
        state:'state',
        zipcode:'zipcode'



    },



         {
        id: 4,
        name: 'Tamil Alejandro Rodriguez',
        address: 'Address1,city,state,zipcode',
        visit:'121 days sice last visit',
        phone:'(787)-758-1616',
        customertype:'customerType',
        email:'hemu@gmail.com',
        distance:'0.15mi',
        customer_number: 'A00015',
        type:'Customer Type',
        last_visit:'24 days since last visit',
        total_sales:'$ 803,774.94',
        sales_in_90_days:'$ 15,0025.36',
        available_Credit:'$14,750.00',
        open_order:'$2,500.00',
        amount_invoiced:'$15,250.00',
        amount_overdue:'$250.00',
        credit_limit:'$30,000',
        payment_term:'NET 15',
        payment_method:'Invoices',
        price_list:'GF',
        street_name:'Street Name',
        city:'city',
        state:'state',
        zipcode:'zipcode'

    },
     {
    id: 5,
        name: 'Tamil Alejandro Rodriguez',
        address: 'Address1,city,state,zipcode',
        visit:'34 days sice last visit',
        phone:'(787)-758-1616',
        customertype:'customer Type',
        email:'rani12@gmail.com',
        distance:'3.36mi',
        customer_number: 'A00096',
        type:'Customer Type',
        last_visit:'24 days since last visit',
        total_sales:'$ 803,774.94',
        sales_in_90_days:'$ 15,0025.36',
        available_Credit:'$14,750.00',
        open_order:'$2,500.00',
        amount_invoiced:'$15,250.00',
        amount_overdue:'$250.00',
        credit_limit:'$30,000',
        payment_term:'NET 15',
        payment_method:'Invoices',
        price_list:'GF',
        street_name:'Street Name',
        city:'city',
        state:'state',
        zipcode:'zipcode'

    },
        
            {

        id: 6,
        name: 'Tamil Alejandro Rodriguez',
        address: 'Address1,city,state,zipcode',
        visit:'128 days sice last visit',
        phone:'(787)-758-1616',
        customertype:'customer Type',
        email:'srivani67@gmail.com',
        distance:'8.82mi',
        customer_number: 'A00015',
        type:'Customer Type',
        last_visit:'24 days since last visit',
        total_sales:'$ 803,774.94',
        sales_in_90_days:'$ 15,0025.36',
        available_Credit:'$14,750.00',
        open_order:'$2,500.00',
        amount_invoiced:'$15,250.00',
        amount_overdue:'$250.00',
        credit_limit:'$30,000',
        payment_term:'NET 15',
        payment_method:'Invoices',
        price_list:'GF',
        street_name:'Street Name',
        city:'city',
        state:'state',
        zipcode:'zipcode'

    }

];

export const RecentvisitList = [
        {
        id: 1,
        name: 'Fernandez Moledo,Inc #3',
        address: 'Address1,city,state,zipcode',
        visit:'12 days sice last visit',
        phone:'(787)-758-1616',
        customertype:'customer Type',
        email:'ravi@gmail.com',
        distance:'0.05mi',
        customer_number: 'A00015',
        type:'Customer Type',
        last_visit:'24 days since last visit',
        total_sales:'$ 803,774.94',
        sales_in_90_days:'$ 15,0025.36',
        available_Credit:'$14,750.00',
        open_order:'$2,500.00',
        amount_invoiced:'$15,250.00',
        amount_overdue:'$250.00',
        credit_limit:'$30,000',
        payment_term:'NET 15',
        payment_method:'Invoices',
        price_list:'GF',
        street_name:'Street Name',
        city:'city',
        state:'state',
        zipcode:'zipcode'

    },
        {
        id: 2,
        name: 'Blanco Velez Stores, Inc',
        address: 'Address1,city,state,zipcode',
        visit:'24 days sice last visit',
        phone:'(787)-758-1616',
        customertype:'customerType',
        email:'siri567@gmail.com',
        distance:'0.15mi',
        customer_number: 'A00107',
        type:'Customer Type',
        last_visit:'24 days since last visit',
        total_sales:'$ 803,774.94',
        sales_in_90_days:'$ 15,0025.36',
        available_Credit:'$14,750.00',
        open_order:'$2,500.00',
        amount_invoiced:'$15,250.00',
        amount_overdue:'$250.00',
        credit_limit:'$30,000',
        payment_term:'NET 15',
        payment_method:'Invoices',
        price_list:'GF',
        street_name:'Street Name',
        city:'city',
        state:'state',
        zipcode:'zipcode'

    }, 
            {
        id: 3,
        name: 'Tamil Alejandro Rodriguez',
        address: 'Address1,city,state,zipcode',
        visit:'34 days sice last visit',
        phone:'(787)-758-1616',
        customertype:'customer Type',
        email:'rani12@gmail.com',
        distance:'3.36mi',
        customer_number: 'A00096',
        type:'Customer Type',
        last_visit:'24 days since last visit',
        total_sales:'$ 803,774.94',
        sales_in_90_days:'$ 15,0025.36',
        available_Credit:'$14,750.00',
        open_order:'$2,500.00',
        amount_invoiced:'$15,250.00',
        amount_overdue:'$250.00',
        credit_limit:'$30,000',
        payment_term:'NET 15',
        payment_method:'Invoices',
        price_list:'GF',
        street_name:'Street Name',
        city:'city',
        state:'state',
        zipcode:'zipcode'

    },
            {
        id: 4,
        name: 'Fernandez Moledo, Inc #6',
        address: 'Address1,city,state,zipcode',
        visit:'88 days sice last visit',
        phone:'(787)-758-1616',
        customertype:'customer Type',
        email:'srivani67@gmail.com',
        distance:'5.89mi',
        customer_number: 'A00135',
        type:'Customer Type',
        last_visit:'24 days since last visit',
        total_sales:'$ 803,774.94',
        sales_in_90_days:'$ 15,0025.36',
        available_Credit:'$14,750.00',
        open_order:'$2,500.00',
        amount_invoiced:'$15,250.00',
        amount_overdue:'$250.00',
        credit_limit:'$30,000',
        payment_term:'NET 15',
        payment_method:'Invoices',
        price_list:'GF',
        street_name:'Street Name',
        city:'city',
        state:'state',
        zipcode:'zipcode'

    },
         {
        id: 5,
        name: 'Tamil Alejandro Rodriguez',
        address: 'Address1,city,state,zipcode',
        visit:'121 days sice last visit',
        phone:'(787)-758-1616',
        customertype:'customerType',
        email:'hemu@gmail.com',
        distance:'0.15mi',
        customer_number: 'A00015',
        type:'Customer Type',
        last_visit:'24 days since last visit',
        total_sales:'$ 803,774.94',
        sales_in_90_days:'$ 15,0025.36',
        available_Credit:'$14,750.00',
        open_order:'$2,500.00',
        amount_invoiced:'$15,250.00',
        amount_overdue:'$250.00',
        credit_limit:'$30,000',
        payment_term:'NET 15',
        payment_method:'Invoices',
        price_list:'GF',
        street_name:'Street Name',
        city:'city',
        state:'state',
        zipcode:'zipcode'

    },
            {
        id: 6,
        name: 'Tamil Alejandro Rodriguez',
        address: 'Address1,city,state,zipcode',
        visit:'128 days sice last visit',
        phone:'(787)-758-1616',
        customertype:'customer Type',
        email:'srivani67@gmail.com',
        distance:'8.82mi',
        customer_number: 'A00015',
        type:'Customer Type',
        last_visit:'24 days since last visit',
        total_sales:'$ 803,774.94',
        sales_in_90_days:'$ 15,0025.36',
        available_Credit:'$14,750.00',
        open_order:'$2,500.00',
        amount_invoiced:'$15,250.00',
        amount_overdue:'$250.00',
        credit_limit:'$30,000',
        payment_term:'NET 15',
        payment_method:'Invoices',
        price_list:'GF',
        street_name:'Street Name',
        city:'city',
        state:'state',
        zipcode:'zipcode'


    }



];


export const overdueList = [

    {
       id: 1,
       amount1: '$303k',
       days1:'Sales in last 90 days',
       amount2: '$25k',
       days2:'4 customers Overdue',
       amount3: '$15k',
       days3:'3 Open Carts'

    }
    
];
export const CartList = [
        {
        id: 1,
        name: 'Nike Mens Legend 2.0 T-Shirt',
        brand: 'Deep Royal Blue | M',
        number:'Item #: 742626-485',
        Quantity:'20',
        uom:'$25.00',
        status:'Remove',
        cartamount:'$250.00',
        
        

    },

        {
        id: 2,
        name: 'Nike Mens Legend 2.0 T-Shirt',
        brand: 'Spring Leaf / Black | M',
        number:'Item #: 742626-485',
        Quantity:'20',
        uom:'$25.00',
        status:'Remove',
        cartamount:'$50.00'
       

    }
    
      
];
export const Totalamount = [
        {
        id: 1,
        subtotal: '$40.00',
        totalcartamt:'$300.00'
        

    }
      
        
];



// WEBPACK FOOTER //
// ./src/app/providers/list-of-customers.ts